import React, { Component } from 'react'
import { localize } from '../../util/Localizer'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import { withStyles } from '@material-ui/core/styles'
import RBButton from '../../controls/RBButton'
import DialogStyles from '../../styles/components/dialog'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

class GenericModal extends Component {
  render () {
    const actions = [
      <RBButton
        key='close'
        label={this.props.CancelButtonText || localize('common.close')}
        className='submitNavButton'
        onClick={this.props.handleClose}
        variant='outlined'
        styles={{ margin: '0px 5px' }}
      />
    ]

    if (this.props.showOk) {
      actions.push(<RBButton
        key='ok'
        label={this.props.OkButtonText || 'Ok'}
        className='submitNavButton'
        primary
        onClick={this.props.handleOk}
        variant='contained'
        styles={{ margin: '0px 5px' }}
      />)
    }

    return (
      <div>
        <Dialog
          className={this.props.classes.baseDialog}
          open={this.props.open}
        >
          <DialogTitle>{localize('common.genericModal.title')}</DialogTitle>
          <DialogContent><p>{this.props.message}</p></DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    messge: ownProps.message
  }
}

const ConnectedGenericModal = connect(mapStateToProps, {}, null, { withRef: true })(injectIntl(GenericModal, { withRef: true }))

const styles = {
  ...DialogStyles
}

export default withStyles(styles)(ConnectedGenericModal)



// WEBPACK FOOTER //
// ./src/widgets/common/GenericModal.js